'use client';

import Image from 'next/image';
import Link from 'next/link';
import { useLocaleTranslation } from '@/hooks/use-locale-translation';
import { generateCompanySlug } from '@/lib/company-utils';
import styles from './home-live.module.css';

/** The profile public/home/company-profile-example.png and
 *  company-documents-example.png (its document cards, mobile) show. */
const PROFILE = {
  name: 'Rolls-Royce Deutschland Ltd & Co KG',
  registerCourt: 'Potsdam',
  registerType: 'HRA',
  registerId: '2731',
};

/**
 * The homepage's second screen on mobile, in place of the live map: what a
 * company profile and its downloadable documents look like, as screenshots
 * that link to the live page.
 */
export function ProfileShowcase() {
  const { t, locale } = useLocaleTranslation();
  const profileHref = generateCompanySlug(PROFILE, locale);
  // The Jahresabschlüsse card's anchor on the company page.
  const docsHref = `${profileHref}#jahresabschluesse`;

  return (
    <section className={`${styles.section} ${styles.pad} ${styles.showcase}`} id="beispiel">
      <div className={`${styles.split} ${styles.head}`}>
        <h2 className={styles.sqLabel}>{t('homeV2.example.label')}</h2>
        <Link href={profileHref} className={styles.showcaseLink}>
          {t('homeV2.example.cta')} →
        </Link>
      </div>
      <Link href={profileHref} className={styles.shot} aria-label={t('homeV2.example.cta')}>
        <Image
          src="/home/company-profile-example.png"
          alt={t('homeV2.example.alt')}
          width={1501}
          height={885}
          sizes="100vw"
        />
      </Link>
      <div className={`${styles.split} ${styles.head}`}>
        <h2 className={styles.sqLabel}>{t('homeV2.example.docsLabel')}</h2>
        <Link href={docsHref} className={styles.showcaseLink}>
          {t('homeV2.example.docsCta')} →
        </Link>
      </div>
      <Link href={docsHref} className={styles.shot} aria-label={t('homeV2.example.docsCta')}>
        <Image
          src="/home/company-documents-example.png"
          alt={t('homeV2.example.docsAlt')}
          width={1290}
          height={1567}
          sizes="100vw"
        />
      </Link>
    </section>
  );
}
